module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/rcs-e5113040b7c92be4a7ad5c655d65880d.png";